import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// CONSTANTS
import { ROUTE_SEARCH } from '@/constants/routes';

// UTILITY
import { analyticsNoSearchResults } from '@/utility/analytics';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { EmptyResults } from './styles';

const NoResults = ({ search, handleClick }) => {
  const [t] = useTranslation();

  useEffect(() => {
    analyticsNoSearchResults({ query: search });
  }, []);

  return (
    <EmptyResults className="empty-results">
      <Typography align="center" variant="body2">
        {t('streamingMarketplaceDiscover.noResults')}
      </Typography>
      <Button
        className="m-t-40 m-b-30"
        color="primary"
        size="medium"
        variant="outlined"
        onClick={() => handleClick('reset')}
      >
        {t('buttons.resetFilters')}
      </Button>
      <RouterLink
        to={`${ROUTE_SEARCH}?search=${search}`}
        className="m-b-10 text-color--default"
        align="center"
        variant="body2"
        onClick={() => handleClick('full-search')}
        component={Typography}
      >
        {t('searchPage.youCanTryToUseFullSearch')} <b className="text-color--primary">"{search}"</b>
      </RouterLink>
    </EmptyResults>
  );
};

NoResults.defaultProps = {
  search: '',
};

NoResults.propTypes = {
  search: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};

export default React.memo(NoResults);
